<div class="message-wrapper-container"
     fxLayout="column"
     fxLayoutAlign="center center"
     fxLayoutGap="1rem">
    <div class="message-container"
         fxLayout="column"
         fxLayoutAlign="center center"
         fxLayoutGap="1rem">
        @if (message?.imageUrl) {
        <img [src]="message.imageUrl">
        }
        <div class="dynamic-font-size-large-container">
            {{message?.message}}
        </div>
        @for (link of message?.links; track link.title) {
        <button mat-raised-button
                color="primary"
                class="message-component-button full-width-container"
                (click)="open(link)">
            {{link.title}}
        </button>
        }
    </div>
</div>
